export enum SvcMediaCarouselRenderMode {
  LIST = 'list',
  ONE_BY_ONE = 'one-by-one',
}
